import { useState, useEffect, useCallback } from 'react';
import {
  ISaveRequestOutput,
  IApiCallStatus,
  useUserContext,
  getHeaders,
  ResponseCSOSHeaders,
  IError,
  IRequest,
  getApproverRequests,
} from '../common';
import { assocPath, pathOr, equals, not } from 'rambda';
import { map as lmap, filter as lfilter } from 'lodash/fp';
import { fold, map as emap } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export function useGetStatusMemberRequests() {
  const [requests, setRequests] = useState<ISaveRequestOutput[]>([]);
  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();

  const { user } = useUserContext();
  const reload = useCallback(() => {
    flow(
      () => setApiCallStatus(null),
      () => flow(getHeaders, emap(handleRequest))(user)
    )();
  }, [user]);

  useEffect(reload, [reload]);

  const handleRequest = (hR: ResponseCSOSHeaders) =>
    getApproverRequests(hR).then(
      fold<IError, IRequest[], void>(
        a => setApiCallStatus(false),

        flow(
          lfilter<IRequest>(
            flow(pathOr('', 'status'), equals('IN_PROCESS'), not)
          ),

          lmap<IRequest, ISaveRequestOutput>(
            flow(
              assocPath<ISaveRequestOutput>('msgCode', null),
              assocPath<ISaveRequestOutput>('msgText', null)
            )
          ),

          setRequests,

          () => setApiCallStatus(true)
        )
      )
    );

  return { apiCallStatus, requests, reload };
}
